module.exports = __webpack_public_path__ + "static/amanat-b05f2636a74097f521747767046c18fd.jpg";